module.exports = __webpack_public_path__ + "img/guide-body-2-1.c0d3557f.png";